<template>
    <div class="price-lists-filters">
        <h3 class="price-lists-filters__title">
            {{ text.searchPriceLists }}
        </h3>
        <div class="row">
            <div class="col-default-5 col-v-tablet-4 col-mobile-12">
                <z-select
                    name="type"
                    :data="data.type"
                    v-model="formData.type"
                    :placeholder="text.type"
                />
            </div>
            <div class="col-default-5 col-v-tablet-4 col-mobile-12">
                <z-select
                    name="year"
                    :data="data.year"
                    v-model="formData.year"
                    :placeholder="text.year"
                />
            </div>
            <div class="col-default-2 col-v-tablet-4 col-mobile-12">
                <z-button
                    size="l"
                    @click="send"
                    class="price-lists-filters__button u-entire-width"
                >{{ text.search }}</z-button>
            </div>
        </div>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'price-lists',
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        initial: {
            type: Object,
            default: () => {}
        }
    },
    data () {
        return {
            formData: {
                type: '',
                year: ''
            },
            text: {
                searchPriceLists: localize({
                    ru: 'Поиск по прайс-листам',
                    en: 'Search for a price-lists'
                }),
                search: localize({
                    ru: 'Найти',
                    en: 'Search'
                }),
                type: localize({
                    ru: 'Строительный сортамент',
                    en: 'Building assortment'
                }),
                year: localize({
                    ru: 'Год',
                    en: 'Year'
                })
            }
        }
    },
    methods: {
        send () {
            this.$emit('search', this.formData)
        }
    }
}
</script>

<style lang="scss">
.price-lists-filters {
    position: relative;
    border: 1px solid $token-colors-black-20;
    padding: 32px;
    margin-bottom: 64px;

    &__title {
        margin-top: 0;
        margin-bottom: 32px;
    }

    &__button {
        &.z-button {
            min-width: 100%;
            height: 100%;
        }
    }
}
</style>
